"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Drawer = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDomInteractions = require("@floating-ui/react-dom-interactions");

var _theming = require("@storybook/theming");

var _framerMotion = require("framer-motion");

var _designSystem = require("@storybook/design-system");

var _IconButton = require("./IconButton");

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var AnimatedOverlay = ( /*#__PURE__*/0, _theming.styled)((0, _framerMotion.motion)(_reactDomInteractions.FloatingOverlay), process.env.NODE_ENV === "production" ? {
  target: "e1imaz2u3"
} : {
  target: "e1imaz2u3",
  label: "AnimatedOverlay"
})(process.env.NODE_ENV === "production" ? {
  name: "2080vl",
  styles: "box-shadow:0px 4px 4px rgba(0, 0, 0, 0.25);z-index:100"
} : {
  name: "2080vl",
  styles: "box-shadow:0px 4px 4px rgba(0, 0, 0, 0.25);z-index:100",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var StorybookLogo = ( /*#__PURE__*/0, _theming.styled)(_designSystem.Logos.Storybook, process.env.NODE_ENV === "production" ? {
  target: "e1imaz2u2"
} : {
  target: "e1imaz2u2",
  label: "StorybookLogo"
})(process.env.NODE_ENV === "production" ? {
  name: "rhxkjj",
  styles: "height:20px"
} : {
  name: "rhxkjj",
  styles: "height:20px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var DialogBody = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1imaz2u1"
} : {
  target: "e1imaz2u1",
  label: "DialogBody"
})(process.env.NODE_ENV === "production" ? {
  name: "hjj54y",
  styles: "background:white;padding:22px 20px 20px 20px;width:100%;height:100%;overflow:scroll"
} : {
  name: "hjj54y",
  styles: "background:white;padding:22px 20px 20px 20px;width:100%;height:100%;overflow:scroll",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var DialogHeader = (0, _theming.styled)("header", process.env.NODE_ENV === "production" ? {
  target: "e1imaz2u0"
} : {
  target: "e1imaz2u0",
  label: "DialogHeader"
})(process.env.NODE_ENV === "production" ? {
  name: "tv6097",
  styles: "display:flex;justify-content:space-between;align-items:center;margin-bottom:20px"
} : {
  name: "tv6097",
  styles: "display:flex;justify-content:space-between;align-items:center;margin-bottom:20px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var Drawer = function Drawer(_ref) {
  var label = _ref.label,
      open = _ref.open,
      setOpen = _ref.setOpen,
      children = _ref.children;

  var _useFloating = (0, _reactDomInteractions.useFloating)({
    open: open,
    onOpenChange: setOpen
  }),
      floating = _useFloating.floating,
      context = _useFloating.context;

  var _useInteractions = (0, _reactDomInteractions.useInteractions)([(0, _reactDomInteractions.useRole)(context), (0, _reactDomInteractions.useDismiss)(context)]),
      getFloatingProps = _useInteractions.getFloatingProps;

  return /*#__PURE__*/_react["default"].createElement(_reactDomInteractions.FloatingPortal, null, /*#__PURE__*/_react["default"].createElement(_framerMotion.AnimatePresence, null, open && /*#__PURE__*/_react["default"].createElement(AnimatedOverlay, {
    lockScroll: true,
    initial: {
      x: '100%'
    },
    animate: {
      x: 0
    },
    exit: {
      x: '100%'
    },
    transition: {
      type: 'tween',
      duration: 0.2,
      ease: [0.25, 1, 0.5, 1]
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactDomInteractions.FloatingFocusManager, {
    context: context
  }, /*#__PURE__*/_react["default"].createElement(DialogBody, getFloatingProps({
    ref: floating,
    'aria-label': label
  }), /*#__PURE__*/_react["default"].createElement(DialogHeader, null, /*#__PURE__*/_react["default"].createElement(StorybookLogo, {
    "aria-label": "Storybook"
  }), /*#__PURE__*/_react["default"].createElement(_IconButton.IconButton, {
    onClick: function onClick() {
      return setOpen(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_designSystem.Icon, {
    icon: "closeAlt",
    "aria-label": "close"
  }))), children)))));
};

exports.Drawer = Drawer;